var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"path-wrapper"},_vm._l((_vm.$store.getters.get_path),function(item,index){return _c('span',{key:index,class:{
      active: item.active,
    },on:{"click":function($event){return _vm.$router.push({ path: item.path })}}},[_vm._v(_vm._s(item.label)+" "),(_vm.$store.getters.get_path.length - 1 > index)?_c('span',{staticClass:"path-icon"},[_vm._v(">")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }